/* eslint-disable */
import React from "react";
import ActivationGooglesheet from "./services/Activation/ActivationGooglesheet";
import ActivationFacebookPixel from "./services/Activation/ActivationFacebookPixel";
import ActivationTiktokPixel from "./services/Activation/ActivationTiktokPixel";
import ActivationSnapchatPixel from "./services/Activation/ActivationSnapchatPixel";
import ActivationGoogleTagManager from "./services/Activation/ActivationGoogleTagManager";
import ActivationMicrosoftClarity from "./services/Activation/ActivationMicrosoftClarity";
import ActivationFacebookApi from "./services/Activation/ActivationFacebookApi";
import ActivationTelegram from "./services/Activation/ActivationTelegram";
import ActivationFacebookDomain from "./services/Activation/ActivationFacebookDomain";
import ActivationPageSpeak from "./services/Activation/ActivationPageSpeak";
import ActivationAbandonedOrders from "./services/Activation/ActivationAbandonedOrders";
import ActivationUpsell from "./services/Activation/ActivationUpsell";
import ActivationConfirmChat from "./services/Activation/ActivationConfirmChat";
import ActivationFoorcall from "./services/Activation/ActivationFoorcall";
import ActivationEcomanger from "./services/Activation/ActivationEcomanger";
import ActivationTrackship from "./services/Activation/ActivationTrackship";
import ActivationTiktokConversion from "./services/Activation/ActivationTiktokConversion";
import ActivationKeepsafe from "./services/Activation/ActivationKeepsafe";
import ActivationCloakingCountrie from "./services/Activation/ActivationCloakingCountrie";
import ActivationOrdersDz from "./services/Activation/ActivationOrdersDz";
import ActivationFacebookCatalog from "./services/Activation/ActivationFacebookCatalog";
import ActivationSawa9ly from "./services/Activation/ActivationSawa9ly";
import ActivationImaginaryDetectionApp from "./services/Activation/ActivationImaginaryDetectionApp";
import ActivationFoorchat from "./services/Activation/Activationfoorchat";
import ActivationDigitalProducts from "./services/Activation/ActivationDigitalProducts";
import ActivationGooglesheetV2 from "./services/Activation/ActivationGooglesheetV2";
import ActivationGooglesheetV3 from "./services/Activation/ActivationGoogleSheetV3";
import ActivationCountrySelector from "./services/Activation/ActivationCountrySelector";
import ActivationMessgesEdit from "./services/Activation/ActivationMessagesEdit";
import ActivationCrossSell from "./services/Activation/ActivationCrossSell";
import ActivationVendex from "./services/Activation/ActivationVendex";
import ActivationCashBack from "./services/Activation/ActivationCashBack";
import ActivationSmartSuivi from "./services/Activation/ActivationSmartSuivi";
import ActivationPrintAgent from "./services/Activation/ActivationPrintAgent";
import ActivationOrderExporting from "./services/Activation/ActivationOrderExporting";
import { useTranslation } from "react-i18next";

export default function ServiceActivation({ service, close }) {
  const { t } = useTranslation();
  if (!service) return null;

  switch (service.id) {
    case "googlesheet":
      return <ActivationGooglesheet close={close} />;

    case "facebookpixel":
      return <ActivationFacebookPixel close={close} />;

    case "tiktokpixel":
      return <ActivationTiktokPixel close={close} />;

    case "snapchatpixel":
      return <ActivationSnapchatPixel close={close} />;

    case "googletagmanager":
      return <ActivationGoogleTagManager close={close} />;

    case "microsoftclarity":
      return <ActivationMicrosoftClarity close={close} />;

    case "facebookapi":
      return <ActivationFacebookApi close={close} />;

    case "telegram":
      return <ActivationTelegram close={close} />;

    case "facebookDomain":
      return <ActivationFacebookDomain close={close} />;

    case "pagespeak":
      return <ActivationPageSpeak close={close} />;

    case "abandonedOrders":
      return <ActivationAbandonedOrders close={close} />;

    case "upsell":
      return <ActivationUpsell close={close} />;

    case "confirmchat":
      return <ActivationConfirmChat close={close} />;

    case "foorcall":
      return <ActivationFoorcall close={close} />;

    case "ecomanger":
      return <ActivationEcomanger close={close} />;

    case "trackship":
      return <ActivationTrackship close={close} />;

    case "tiktokaconversion":
      return <ActivationTiktokConversion close={close} />;

    case "keepsafe":
      return <ActivationKeepsafe close={close} />;

    case "cloakingcountries":
      return <ActivationCloakingCountrie close={close} />;

    case "orderdz":
      return <ActivationOrdersDz close={close} />;

    case "facebookcatalog":
      return <ActivationFacebookCatalog close={close} />;

    case "sawa9ly":
      return <ActivationSawa9ly close={close} />;

    case "imaginaryDetectionApp":
      return <ActivationImaginaryDetectionApp close={close} />;
    case "foorchat":
      return <ActivationFoorchat close={close} />;
    case "digitalProducts":
      return <ActivationDigitalProducts />;
    case "googlesheetV2":
      return <ActivationGooglesheetV2 close={close} />;

    case "googlesheetV3":
      return <ActivationGooglesheetV3 close={close} />;

    case "CountrySelector":
      return <ActivationCountrySelector close={close} />;
    case "orderMessagesEnabled":
      return <ActivationMessgesEdit close={close} />;

    case "CrossSell":
      return <ActivationCrossSell close={close} />;

    case "Vendex":
      return <ActivationVendex close={close} />;

    case "smartsuivi":
      return <ActivationSmartSuivi close={close} />;

    case "printAgent":
      return <ActivationPrintAgent close={close} />;

    case "orderExporting":
      return <ActivationOrderExporting close={close} />;

    case "CashBack":
    default:
      return (
        <div>
          <h4 className="font-semibold text-lg">
            {t("servicePageActivation.title")}
          </h4>
          <br />
          <p className="text-gray-600">
            {t("servicePageActivation.description")}
          </p>
        </div>
      );
  }
}
